/* Date helpers (local time, YYYY-MM-DD) used by the sales reports' presets. */
export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const monday = (d) => addDays(d, -((d.getDay() + 6) % 7));
export const monthStart = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
export const monthEnd = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
export const today = () => new Date();
